/**
 * Operations permission keys (catalog `ops.*`, docs/contracts/operations.md §6). The UI hides what a key does not allow;
 * the API checks the same keys and, per operation line, the user's department data scope (OP1 / OP13).
 */
export const opsPermissions = {
  moduleView: "ops.operations.view",
  lineView: "ops.line.view",
  lineCreate: "ops.line.create",
  lineUpdate: "ops.line.update",
  lineDelete: "ops.line.delete",
  settingsView: "ops.settings.view",
  settingsUpdate: "ops.settings.update",
  offerView: "ops.offer.view",
  offerCreate: "ops.offer.create",
  offerUpdate: "ops.offer.update",
  offerDelete: "ops.offer.delete",
  offerApprove: "ops.offer.approve",
  offerPrint: "ops.offer.print",
  contractView: "ops.contract.view",
  contractCreate: "ops.contract.create",
  contractUpdate: "ops.contract.update",
  contractPost: "ops.contract.post",
  contractDelete: "ops.contract.delete",
  contractPrint: "ops.contract.print",
  contractAmend: "ops.contract.amend",
  contractApprove: "ops.contract.approve",
  contractBill: "ops.contract.bill",
  contractDeposit: "ops.contract.deposit",
  contractRefund: "ops.contract.refund",
  jobView: "ops.job.view",
  jobCreate: "ops.job.create",
  jobUpdate: "ops.job.update",
  jobPost: "ops.job.post",
  jobDelete: "ops.job.delete",
  revenueView: "ops.revenue.view",
  revenuePost: "ops.revenue.post",
  projectView: "ops.project.view",
} as const;

/** Plan module of Operations (optional, P6). */
export const opsModule = "operations";

/** The Operations settings group (`/platform/settings/ops`). */
export const opsSettingsGroup = "ops";

/** Record types of Operations (Work tasks, forms and checklists on a record). */
export const opsRecordTypes = {
  offer: "ops.offer",
  contract: "ops.contract",
  job: "ops.job",
} as const;
